import { filter, find } from 'lodash';
import { getDefaultCouponState } from '@/views/config/coupon/helper/utils';
import { couponDiscountTypeMap, couponSourceTypeMap, couponTypes } from '@/views/config/coupon/helper/constant';

/**
 * Just for verify coupon api format coupon result info
 * @param couponResult
 * @param options
 * @return {any}
 */
export const convertVerifyCouponResult2State = (couponResult = {}, options = {
  couponCode: '',
  allowChange: false,
}) => {
  const { couponCode = '', allowChange = true } = options;
  const defaultCouponState = getDefaultCouponState();

  if (couponResult.thresholdList) { // threshold coupon
    return {
      ...defaultCouponState,
      ...couponResult,
      couponType: couponTypes.MARKETING,
      couponSourceType: couponSourceTypeMap.threshold,
      couponCode,
      allowChange,
    };
  } else if (couponResult.discount) { // account level coupon
    return {
      ...defaultCouponState,
      account_discount: couponResult.discount * 1,
      couponType: couponTypes.ACCOUNT,
      couponCode,
      allowChange,
    };
  } else { // timebase | marketing coupon | mlm
    const couponSourceType = find(couponResult, (v) => !!v.couponCategory)?.couponCategory;

    return {
      ...defaultCouponState,
      couponType: couponTypes.TIMEBASE,
      timeBase: filter(couponResult, (item) => !!item.planCode).map(v => {
        return {
          plan_code: v.planCode,
          category: v.couponCategory,
          discount: v.couponDiscount,
          discountType: v.couponDiscountType || couponDiscountTypeMap.percentage,
          expireDate: v.couponExpireDate,
          // coupon definition type
          couponDefType: v?.couponDefType, //  1, 2 -> mlm
          // coupon discount period
          couponPeriod: v?.couponPeriod, // int type
        };
      }),
      tncMessage: find(couponResult, (v) => !!v.tncMessage)?.tncMessage,
      couponCode,
      allowChange,
      // In order to distinguish whether the current coupon is a marketing coupon
      couponSourceType,
      // just couponSourceType equal mt, mark fromCampaignLink is true
      fromCampaignLink: couponSourceType === couponSourceTypeMap.marketing,
    };
  }
};

/**
 * note: It is easy to identify whether the parameters passed by the backend meet expectations
 * @return {PreloadCouponBean}
 */
export const convertCampaignCouponResult2State = (marketingCoupon = {}) => {
  const {
    couponCode,
    discountInfo,
    billingCycle,
    tncMessage,
    multipleTargetSwitch,
    defaultDiscountInfo,
    thresholdList = [],
    supportPlanCodeList = [],
    promoAllPlans = false,
    discountInfoExtension,
    couponSourceType,
    subscriptionLevelAction,
  } = marketingCoupon;

  const thresholdCoupon = thresholdList.length ? {
    promoAllPlans,
    thresholdList,
    supportPlanCodeList,
    couponSourceType: couponSourceTypeMap.threshold,
  } : { couponSourceType };

  return {
    ...getDefaultCouponState(),
    couponCode,
    tncMessage,
    billingCycle,
    discountInfo,
    defaultDiscountInfo,
    discountInfoExtension, // Just for extension increase/decrease plan (eg: pro monthly plan)
    // switch for default preload source (true -> defaultDiscountInfo, false -> discountInfo)
    multipleTargetSwitch,
    // threshold, mt, preload etc...
    couponSourceType,
    couponType: couponTypes.MARKETING,
    fromPreloadLink: true, // from campaign link
    subscriptionLevelAction, // subscription level  1 -> NEW_SUBSCRIPTION; 2 -> REPLACE_SUBSCRIPTION; 3 -> MODIFY_SUBSCRIPTION
    ...thresholdCoupon,
  };
};

/**
 * convert subscription to coupon state
 * @param subscriptions
 * @return {{expireDate: *, discountType}[]}
 */
export const convertSubscriptionResult2State = (subscriptions = []) => {
  return subscriptions.filter(v => v.discount).map(v => {
    return {
      ...v,
      expireDate: v?.expire_date,
      discountType: v?.couponDiscountType || couponDiscountTypeMap.percentage,
    };
  });
};

/**
 *
 * @param coupon {PreloadCouponBean}
 */
export const convertPartnerReferCouponResult2State = (coupon = {}) => {
  const {
    couponCode,
    discountInfo,
    tncMessage,
    multipleTargetSwitch,
    defaultDiscountInfo,
    discountInfoExtension,
    subscriptionLevelAction,
  } = coupon;

  return {
    ...getDefaultCouponState(),
    couponCode,
    tncMessage,
    discountInfo,
    defaultDiscountInfo,
    discountInfoExtension, // Just for extension increase/decrease plan (eg: pro monthly plan)
    multipleTargetSwitch, // switch for default preload source (true -> defaultDiscountInfo, false -> discountInfo)
    couponType: couponTypes.MARKETING,
    couponSourceType: couponSourceTypeMap.partnerRefer,
    fromPreloadLink: true, // from partner refer code
    subscriptionLevelAction, // subscription level  1 -> NEW_SUBSCRIPTION; 2 -> REPLACE_SUBSCRIPTION; 3 -> MODIFY_SUBSCRIPTION
  }
}
